import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlignRightJustify = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 8H21M3 12H21M3 16H21M11 20H21M3 4H21",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAlignRightJustify;
